import React from "react";
import PropTypes from "prop-types";
import {navigate, Link} from "gatsby";
import {css} from "@emotion/react";
import {breakpoints} from "~styles/global";
import Section from "~components/Section";
import {Larr} from "../../Svg";
import {Location} from "@reach/router";

const BackButtonSection = ({className, message, customBackLink}) => {
  const {mobile} = breakpoints;

  return (
    <Section
      className={className}
      css={css`
        padding-top: 20px;
        height: 40px;
        ${mobile} {
          padding-top: 3px;
        }
      `}
    >
      <Location>
        {({location}) => {
          if (location.state) {
            return (
              <div
                css={css`
                  grid-column: span 12;
                `}
              >
                <button
                  onClick={() => navigate(-1)}
                  className="h6"
                  css={css`
                    text-align: left;
                  `}
                >
                  <Larr
                    css={css`
                      width: 9px;
                      height: 9px;
                      margin-right: 5px;
                    `}
                  />
                  {message}
                </button>
              </div>
            );
          } else {
            return (
              <div
                css={css`
                  grid-column: span 12;
                `}
              >
                <button
                  onClick={() => navigate(customBackLink)}
                  className="h6"
                  css={css`
                    text-align: left;
                  `}
                >
                  <Larr
                    css={css`
                      width: 9px;
                      height: 9px;
                      margin-right: 5px;
                    `}
                  />
                  {message}
                </button>
              </div>
            );
          }
        }}
      </Location>
    </Section>
  );
};

BackButtonSection.propTypes = {};

BackButtonSection.defaultProps = {};

export default BackButtonSection;
